import axios from 'axios';

type RecipeConflictResponse = {
  code?: string;
  error?: string;
  message?: string;
};

export const PUBLIC_RECIPE_NAME_CONFLICT_CODE = 'PUBLIC_RECIPE_NAME_CONFLICT';

export function getPublicRecipeNameConflictMessage(error: unknown): string | null {
  const responseData = axios.isAxiosError(error)
    ? error.response?.data as RecipeConflictResponse | undefined
    : undefined;

  if (!responseData || responseData.code !== PUBLIC_RECIPE_NAME_CONFLICT_CODE) {
    return null;
  }

  return responseData.error || responseData.message || 'A publicly shared recipe already uses this name.';
}
